import React, { forwardRef } from "react"
import withStyles from "react-jss"
import { BarViz, Wave } from "."
import colors from "../data/colors"
import {
  BREAKPOINT,
  CARD_VIZ_HEIGHT,
  CARD_VIZ_HEIGHT_MOBILE,
} from "../data/uniqueValues"

const styles = {
  container: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "60vh",
    width: "100%",
    maxWidth: "1100px",
    // padding: "7rem 0 6rem 0",
    margin: "10rem 0",
    boxSizing: "border-box",
    background: (props) => props.palette.primary,
    // mixBlendMode: "multiply",
    [`@media only screen and (max-width: ${BREAKPOINT}px)`]: {
      height: "100vh",
      paddingBottom: "4rem",
      margin: 0,
    },
  },
  viz: {
    position: "absolute",
    margin: 0,
    // width/height in ratio 3/1
    width: "420px",
    height: `${CARD_VIZ_HEIGHT}px`,
    top: "-70px",
    [`@media only screen and (max-width: ${BREAKPOINT}px)`]: {
      width: "320px",
      height: `${CARD_VIZ_HEIGHT_MOBILE}px`,
      top: "-54px",
    },
  },
}

const Card = ({ classes, children, palette, viz, loading, vizRef }, ref) => {
  return (
    <div className={classes.container} ref={ref}>
      {!loading ? (
        <div className={classes.viz} ref={vizRef}>
          {viz === "bar" ? (
            <BarViz topColor={palette.primary} bottomColor={colors.white} />
          ) : (
            <Wave
              topColor={palette.primary}
              bottomColor={palette.secondary}></Wave>
          )}
        </div>
      ) : null}
      {children}
    </div>
  )
}

export default withStyles(styles)(forwardRef(Card))
